import { PropsWithChildren, createContext, useContext, useMemo } from 'react';

export interface ICompanyContext {
  companyId: number;
}

const CompanyContext = createContext({} as ICompanyContext);

export const useCompanyContext = () => useContext(CompanyContext);

const CompanyProvider: React.FC<PropsWithChildren<ICompanyContext>> = ({
  companyId,
  children,
}) => (
  <CompanyContext.Provider value={useMemo(() => ({ companyId }), [companyId])}>
    {children}
  </CompanyContext.Provider>
);

export default CompanyProvider;
